import {createRoot, hydrateRoot} from 'react-dom/client';
import MissionVision from '../pages/MissionVision/MissionVision'
import "../index.css";
import "../pages/MissionVision/MissionVision.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<MissionVision {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <MissionVision {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).MissionVisionVC = {mount, hydrate, unmount}